import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border mt-16" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
        <span className="font-display italic text-base">Lyric Lock</span>
        <nav className="flex items-center gap-5 flex-wrap justify-center">
          <Link to="/how-it-works" className="hover:text-foreground transition-colors" data-testid="footer-how-link">
            How it works
          </Link>
          <Link to="/terms" className="hover:text-foreground transition-colors" data-testid="footer-terms-link">
            Terms of Service
          </Link>
          <Link to="/privacy" className="hover:text-foreground transition-colors" data-testid="footer-privacy-link">
            Privacy Policy
          </Link>
          <Link to="/contact" className="hover:text-foreground transition-colors" data-testid="footer-contact-link">
            Contact
          </Link>
        </nav>
        <span className="font-mono text-xs uppercase tracking-[0.2em]">Made for singers</span>
      </div>
    </footer>
  );
}
